




















































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import search from '@/store/modules/search';

@Component
export default class Menubar extends Vue {
  searchHandle: number = -1;

  search() {
    window.clearTimeout(this.searchHandle);
    search.search(this.searchTerm);
    if (this.searchTerm === '' && this.$router.currentRoute.name === 'search') {
      this.$router.push({ name: 'start' });
    } else if (
      this.searchTerm !== '' &&
      this.$router.currentRoute.name !== 'search'
    ) {
      this.$router.push({ name: 'search' });
    }
  }

  logout() {
    user.logout();
    this.$router.push({ name: 'start' });
  }

  get userName() {
    return user.user ? `${user.user.FirstName} ${user.user.LastName}` : '???';
  }

  get searchTerm(): string {
    return search.term;
  }

  set searchTerm(term: string) {
    search.setTerm(term);

    window.clearTimeout(this.searchHandle);
    this.searchHandle = window.setTimeout(() => this.search(), 500);
  }
}
